// @flow

import React from "react";
import ReactDOM from "react-dom";
import PubSub from "../modules/util/pubsub";
import GoogleMap from "../components/GoogleMap";

const init = () => {
    const els = document.querySelectorAll(".google-map__loader");
    els.forEach((el: HTMLElement) => {
        const data = JSON.parse(el.getAttribute("data-googlemaps") || "");
        if (data) {
            ReactDOM.render(
                <GoogleMap
                    className={data.className}
                    lat={data.lat}
                    lng={data.lng}
                    width={data.width}
                    height={data.height}
                    zoom={data.zoom}
                    marker={data.marker}
                />,
                el
            );
        }
    });
};

PubSub.subscribe("google-maps-loaded", init);
